import React from 'react'
import { Panel } from '../ui/Panel'

export const Connecting: React.FC = () => (
    <Panel>
        <div id="welcome">
            <h1 className="header">
            Loading...
            </h1>
        </div>
    </Panel>
)
